import React, { ButtonHTMLAttributes } from "react";
import { animateSpinIcon } from "../../assets/icons/SvgIconList";
import { cn } from "../../lib";

type TCustomButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  ClassName?: string;
  loading?: boolean;
};

const ICButton: React.FC<TCustomButtonProps> = ({
  children,
  className,
  loading,
  ...rest
}) => {
  return (
    <button
      disabled={loading}
      className={cn(
        `rounded-md px-4 py-2 text-on-accent bg-accent-emphasis text-nowrap w-full`,
        {
          [`${className}`]: className,
        }
      )}
      type="submit"
      {...rest}
    >
      {loading ? (
        <div className="flex justify-center">
          <div className="h-5 w-5 m-0.5">{animateSpinIcon}</div>
        </div>
      ) : (
        children
      )}
    </button>
  );
};

export default ICButton;
